<template lang="pug">
#modal-selecao-tipo-alerta
    el-dialog(
        :title="$t('mensagens.home.centralAlertas.visualizarAlertas')",
        :width='width',
        :visible.sync='show_',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        show-close,
        @close='closeDialog()'
    )
        div
            .text-left.mb-3.mt-1
                span.font-weight-normal
                    | {{ $t('mensagens.home.centralAlertas.selecionarTipoAlerta') }}

            BaseButton.central-alertas__acesso_btn(
                type='primary',
                icon='lyra-icon lyra-arvore'
                @click='abrirMonitoramentoSocioambiental()'
            )
                | {{ $t('mensagens.home.centralAlertas.modalSelecaoAlerta.alertasSocioambientais') }}

            BaseButton.central-alertas__acesso_btn.mt-3(
                v-if="monitoramentoAgricolaAcess && !ambienteAr"
                type='primary',
                icon='lyra-icon lyra-agricola',
                @click='abrirMonitoramentoAgricola()',
                :disabled='ambientePy && !monitoramentoAgricolaAcess'
            )
                | {{ $t('mensagens.home.centralAlertas.modalSelecaoAlerta.alertasAgricolas') }}

        .dialog-footer(slot='footer', v-if='mostrarBotaoVoltar')
            BaseButton.btn-cancelar(type='outline', @click='closeDialog()') {{ $t('mensagens.comuns.cancelar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'ModalSelecaoTipoAlerta',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        width: {
            type: String,
            default: '500px'
        },
        mostrarBotaoVoltar: {
            type: Boolean,
            default: true
        },
        periodoAlerta: {
            type: String,
            default: 'diario',
            required: true
        }
    },

    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['ambientePy', 'ambienteAr']),
        monitoramentoAgricolaAcess() {
            return this.usuarioLogado.monitoramentoAgricolaAccess;
        }
    },

    data() {
        return {
            show_: false
        };
    },

    watch: {
        show: {
            handler() {
                this.show_ = this.show;
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            this.show_ = false;
            this.$emit('closeDialog');
        },

        abrirMonitoramentoSocioambiental() {
            this.$router.push({
                name: 'MonitoramentoSocioambiental',
                params: { periodoAlertaSocioambiental: this.periodoAlerta }
            });
        },

        abrirMonitoramentoAgricola() {
            this.$router.push({
                name: 'MonitoramentoAgricola',
                params: { periodoAlertaAgricola: this.periodoAlerta }
            });
        }
    }
};
</script>

<style lang="scss">
#modal-selecao-tipo-alerta {
    .el-dialog__footer {
        margin-top: 0px;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;
    }

    .btn-cancelar {
        border: 1px solid var(--primary);
    }

    .el-dialog__close {
        padding: 10px 20px !important;
        color: #3B3B3B;
        &:before {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__header {
        padding: 10px 20px !important;
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
        }
    }

    .el-dialog__headerbtn {
        top: 0;
        right: 0;
    }

    .font-bold {
        font-weight: 600;
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }

    .central-alertas__acesso_btn {
        width: 100%;
        margin-left: 0;
        height: 40px;
        padding-top: 5px;
        span {
            margin-left: 5px;
        }
    }

    .lyra-agricola::before {
        -webkit-mask: url(../../assets/lyra-icons/svg/agricola.svg) no-repeat 50% 50%;
        mask: url(../../assets/lyra-icons/svg/agricola.svg) no-repeat 50% 50%;
        mask-size: cover;
        -webkit-mask-size: cover;
        height: 18px;
        width: 18px;
    }

    .lyra-arvore::before {
        -webkit-mask: url(../../assets/lyra-icons/svg/arvore.svg) no-repeat 50% 50%;
        mask: url(../../assets/lyra-icons/svg/arvore.svg) no-repeat 50% 50%;
        mask-size: cover;
        -webkit-mask-size: cover;
        height: 18px;
        width: 18px;
    }
}
</style>
